import MedagliereComponent from "../components/medagliere/MedagliereComponent";

import { useState, useEffect } from "react";
import { getMedalCount } from "../data/medalsRepository.js";
import { getNationalTitleCount } from "../data/titlesRepository.js";

function Medagliere() {
  const [openSeason, setOpenSeason] = useState(null);
  const [medalCount, setMedalCount] = useState([]);
  const [nationalTitlesCount, setNationalTitlesCount] = useState([]);

  const handleToggle = (index) => {
    setOpenSeason(openSeason === index ? null : index);
  };

  useEffect(() => {
    getMedalCount().then((data) => {
      setMedalCount(data);
    });

    getNationalTitleCount().then((data) => {
      setNationalTitlesCount(data);
    });
  }, []);

  return (
    <div className="">
      <div className="overflow-hidden">
        {medalCount.map((medals, index) => (
          <MedagliereComponent
            key={index}
            medals={medals}
            nationalTitles={nationalTitlesCount[medals.season]}
            open={openSeason === index}
            onToggle={() => handleToggle(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default Medagliere;
